const WbsTabs = () => {
    const tabsItems = document.querySelectorAll('.wbs-cookie-modal__nav-item');
    const tabsPanels = document.querySelectorAll('.wbs-cookie-modal__panel');

    if (!tabsItems.length) return;

    const btnPersonalise = document.getElementById('WbsCookieBtnPersonalise');
    const btnAcceptSelected = document.getElementById('WbsCookieBtnAcceptSelected');
    const optionalTab = document.getElementById('WbsCookieTabOptional');


    const toggleButtonsVisibility = (toggleValue) => {
        if (toggleValue === 'WbsOptionalContent') {
            btnAcceptSelected.classList.remove('hidden');
            btnPersonalise.classList.add('hidden');
        } else {
            btnAcceptSelected.classList.add('hidden');
            btnPersonalise.classList.remove('hidden');
        }
    }


    const activateTab = (tab) => {
        tabsPanels.forEach(panel => panel.classList.remove('active'));
        tabsItems.forEach(item => item.classList.remove('active'));
        tab.classList.add('active');

        const content = document.getElementById(tab.dataset.toggle);
        content.classList.add('active');
    }

    btnPersonalise.addEventListener('click', () => {
        activateTab(optionalTab);
        toggleButtonsVisibility(optionalTab.dataset.toggle);
    });

    tabsItems.forEach(tabItem => {
        tabItem.addEventListener('click', (e) => {
            e.preventDefault();
            activateTab(tabItem);
            toggleButtonsVisibility(tabItem.dataset.toggle);
        });
    });
};

export default WbsTabs;
